import clsx from "clsx";
import { ProjectCard } from "../ProjectCard";
import type { ProjectsGridProps } from "./projectsGrid.types";

export function ProjectsGrid({
  projects,
  viewMode,
  onDeleteProject,
  isDeleting,
}: ProjectsGridProps) {
  return (
    <div
      className={clsx(
        viewMode === "grid"
          ? "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6"
          : "space-y-4"
      )}
    >
      {projects.map((project) => (
        <ProjectCard
          key={project.id}
          project={project}
          viewMode={viewMode}
          onDelete={() => onDeleteProject(project.id)}
          isDeleting={isDeleting}
        />
      ))}
    </div>
  );
}